import { createSlice } from "@reduxjs/toolkit";

export interface SettingsPopupState {
  isOpen: boolean;
}

const initialState: SettingsPopupState = {
  isOpen: false,
};

export const settingsPopupSlice = createSlice({
  name: "settingsPopup", // The name of the slice in the Redux state
  initialState,
  reducers: {
    openSettingsPopup: (state) => {
      state.isOpen = true;
    },
    closeSettingsPopup: (state) => {
      state.isOpen = false;
    },
    toggleSettingsPopup: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openSettingsPopup, closeSettingsPopup, toggleSettingsPopup } =
  settingsPopupSlice.actions;

export default settingsPopupSlice.reducer;
